import { cn } from "@racoon/ui";

export function CardContentWrapper({
  children,
  hasDivider = true,
  className,
}: {
  children: React.ReactNode;
  hasDivider?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "w-full rounded-2xl border border-slate-200 bg-white",
        hasDivider && "divide-y divide-slate-200",
        className,
      )}
    >
      {children}
    </div>
  );
}
